import { render, staticRenderFns } from "./BrowseRetailers.vue?vue&type=template&id=3aa91ec3&"
import script from "./BrowseRetailers.vue?vue&type=script&lang=js&"
export * from "./BrowseRetailers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa91ec3')) {
      api.createRecord('3aa91ec3', component.options)
    } else {
      api.reload('3aa91ec3', component.options)
    }
    module.hot.accept("./BrowseRetailers.vue?vue&type=template&id=3aa91ec3&", function () {
      api.rerender('3aa91ec3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/shop/finder/widgets/BrowseRetailers.vue"
export default component.exports